// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingTemplateBanner_wrapper__Bq5XZ"};